module.exports = __webpack_public_path__ + "static/9-57744bf075be374843c14fe0a09f3e67.jpg";